import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Toast from '../components/Toast';
import './Contact.css';

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("access_key", "02245e2e-ad7e-4821-9666-bb94e6c49e74");
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("company", formData.company);
      formDataToSend.append("message", formData.message);

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formDataToSend
      });

      const data = await response.json();

      if (response.ok) {
        setToast({ message: t('contact.thankYouMessage'), type: 'success' });
        setFormData({ name: '', email: '', company: '', message: '' });
      } else {
        setToast({ message: "Error: " + (data.message || "Something went wrong. Please try again."), type: 'error' });
      }
    } catch (error) {
      setToast({ message: "Something went wrong. Please try again.", type: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
      <section className="page-header">
        <div className="header-container">
          <h1>{t('contact.title')}</h1>
          <p>{t('contact.subtitle')}</p>
        </div>
      </section>

      <section className="contact-section">
        <div className="contact-container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>{t('contact.letsWorkTogether')}</h2>
              <p>{t('contact.description')}</p>

              <div className="info-blocks">
                <div className="info-block">
                  <h3>{t('contact.emailLabel')}</h3>
                  <a href="mailto:info@mdgconsulting.eu">info@mdgconsulting.eu</a>
                </div>

                <div className="info-block">
                  <h3>{t('contact.phone')}</h3>
                  <a href={`tel:${t('contact.phoneValue')}`}>{t('contact.phoneValue')}</a>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">{t('contact.name')} *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">{t('contact.email')} *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="company">{t('contact.company')}</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">{t('contact.message')} *</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows="6"
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>

              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                {isSubmitting ? "Sending..." : t('contact.send')}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
